// extracted by mini-css-extract-plugin
module.exports = {"stores-banner":"storesBanner_stores-banner__owwYz","storesBanner":"storesBanner_stores-banner__owwYz"};